export const seasonalIssues = [
  {
    label: 'The Spring Issue',
    number: 'No. 10',
    title: 'A season for becoming visible.',
    description: 'New essays, rituals, and encounters for the chapter that asks you to step into the light.',
    image: 'https://images.unsplash.com/photo-1490750967868-88aa4486c946?auto=format&fit=crop&w=1200&q=85',
    accent: '#27b8e6',
    action: 'Read the spring edit',
    target: 'stories'
  },
  {
    label: 'The Summer Issue',
    number: 'No. 11',
    title: 'Make room for pleasure.',
    description: 'A sun-warmed collection of stories and objects for a life lived with more appetite.',
    image: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1200&q=85',
    accent: '#ef476f',
    action: 'Explore summer stories',
    target: 'stories'
  }
];

export const seasonalCollections = [
  {
    label: 'Seasonal Collection',
    title: 'The Soft Reset',
    description: 'A considered parcel of small luxuries for clearing space, changing pace, and beginning gently.',
    image: 'https://images.unsplash.com/photo-1544816155-12df9643f363?auto=format&fit=crop&w=1200&q=85',
    accent: '#c77b58',
    action: 'Shop the collection',
    target: 'shop'
  },
  {
    label: 'Limited Collection',
    title: 'The Long Weekend',
    description: 'Objects for disappearing beautifully: a slower morning, an open suitcase, and nowhere urgent to be.',
    image: 'https://images.unsplash.com/photo-1521336575822-6da63fb45455?auto=format&fit=crop&w=1200&q=85',
    accent: '#5a189a',
    action: 'Find your parcel',
    target: 'shop'
  }
];